export default __webpack_public_path__ + "static/chuck-5b809da6767a9503806ed33b51869fd6.png";